<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const IncorrectIcon = getIcon("IncorrectIcon");
</script>

{#if typeof IncorrectIcon === 'string'}
	<img src={IncorrectIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof IncorrectIcon === 'function'}
	<svelte:component this={IncorrectIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
